<template>
		<div>
			<history-grant-access-menu v-model="showGrantAccessHistoryModal"></history-grant-access-menu>
			<div class="backgroundOverlay" v-show="$store.state.layout.showMenu"></div>
			<transition name="slide-fade-left" @after-enter="onAfterEnterMenuTransition" @before-leave="onBeforeLeaveMenuTransition">
				<div class="menuOverlay" v-if="$store.state.layout.showMenu" v-click-outside="hideMenu" @click="handleMenuClick">
					<button id="navbar-toggler" @click="hideMenu" type="button" class="btn-close" aria-label="Close">
						<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" :color="WHITE_COLOUR" :svgClasses="caretIconClasses" />
					</button>
					<div class="overlayItems">
						<b-row class="profile" v-if="$store.state.session.user">
							<b-col class="text-bold" cols="12">
								<img class="profile-pic mr-2 d-inline-block" :src="$store.state.session.user.photo" />
								<p @click="goProfile" class="ml-0 d-inline-block text-transform-uppercase font-weight-bold text-underline">{{ $store.state.session.user.name }}</p>
							</b-col>
							<b-col cols="12" v-if="$store.getters['session/userIsPatient']">
								<!-- <base-button outline white @click="changeUser" size="sm" class="mt-2 btn-change-user">{{ $t('menu.change-user') }}</base-button> -->
									<a @click="$store.commit('layout/toggleChangeUserModalVisible')" class="small btn-change-user">{{ $t('menu.change-user') }}</a>
							</b-col>
						</b-row>
						<hr class="divider">
						<div v-if="!inPanel && $store.getters['session/userIsPatient']">
							<base-button outline white href="/patient" size="sm">
								<router-link to="/patient" tag="span">
									{{ $t('private-layout.home') }}
								</router-link>
							</base-button>
							<hr class="divider">
						</div>
						<div v-if="menuServiceItems && menuServiceItems.length > 0">
							<p id="services-toggler" @click="toggleShowServicesMenu" class="menuItem">
								{{  $t('private-layout.services') }} 
								<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" :color="WHITE_COLOUR" class="ml-1" :svgClasses="caretSubMenuClass" :height="12" :width="12"/>
							</p>
							<CollapseTransition>
								<div v-if="showServicesMenu" class="submenu pl-3 mt-3">
									<div v-for="(item, index) in menuServiceItems" :key="`list-items-${index}`">
										<a @click="item.action">
											<p class="menuItem">{{ item.title }}</p>
										</a>
										<hr v-if="!isLastItem(index, menuServiceItems)">
									</div>
								</div>
							</CollapseTransition>
							<hr>
						</div>
						<div v-if="$store.getters['session/userIsPatient']">
							<div v-for="(i, index) in notTabMenuItems"  :key="i.title">
								<a @click="onTabClick(i)">
									<p class="menuItem">{{ i.title }}</p>
									<b-badge variant="secondary" v-if="i.bubble" class="ml-1">{{ i.bubble }}</b-badge>
								</a>
							<hr v-if="!isLastItem(index, notTabMenuItems)">
							</div>
							<hr class="divider">
						</div>
						<div>
							<div v-for="(i, index) in mainMenuItems" :key="i.title">
								<a @click="onTabClick(i)">
									<p class="menuItem">{{ i.title }}</p>
									<b-badge variant="secondary" v-if="i.bubble" class="ml-1">{{ i.bubble }}</b-badge>
								</a>
							<hr v-if="!isLastItem(index, mainMenuItems)">
							</div>
							<hr class="divider">
						</div>
						<div v-if="!$store.getters['session/userIsPatient']">
							<a v-if="$store.getters['session/userIsProfessional']">
								<p class="menuItem">{{ $t('private-layout.telemonitoring') }}</p>
							</a>
							<hr v-if="$store.getters['session/userIsProfessional']">
							<a>
								<p class="menuItem">{{ $t('private-layout.dashboard') }}</p>
							</a>
							<hr class="divider">
						</div>
						<lang-selector :color="WHITE_COLOUR" enablePortuguese labeled class="d-inline-block mr-4 text-center font-weight-normal"></lang-selector>
						<hr>
						<a v-if="$store.state.session.user" @click="logOff">
							<p class="menuItem">{{ $t('logOff') }}</p>
						</a>
					</div>
				</div>
			</transition>
		</div>
</template>

<script>
import HistoryGrantAccessMenu from '@/components/shared/HistoryGrantAccessMenu'
import layoutMixin from '@/mixins/layout.mixin'
import accountMixin from '@/mixins/account.mixin'
import i18nMixin from '@/mixins/i18n.mixin'
import LangSelector from '@/components/base/LangSelector'
import { mapActions } from 'vuex'
import { BBadge } from 'bootstrap-vue'

const I18N_FILE = 'private-layout'

export default {
	mixins: [layoutMixin, accountMixin, i18nMixin(I18N_FILE)],
	components: {
		HistoryGrantAccessMenu,
		LangSelector,
		BBadge
	},
	props: {
		menuItems: {
			type: Array,
			required: true
		},
		menuServiceItems: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	data () {
		return {
			showGrantAccessHistoryModal: false,
			showServicesMenu: false,
			showToggler: false
		}
	},
	methods: {
		...mapActions('layout', ['hideMenu']),
		filterMenuItems (items) {
			return items.filter(item => item.hideSm !== true)
		},
		isLastItem (index, items) {
			return index === items.length - 1
		},
		onAfterEnterMenuTransition () {
			this.showToggler = true
		},
		onBeforeLeaveMenuTransition () {
			this.showToggler = false
		},
		handleMenuClick (event) {
			const clickedElem = event.target
			if (!clickedElem.closest('#services-toggler')) {
				this.hideMenu()
			}
		}
	},
	computed: {
		caretIconClasses () {
			return !this.$store.state.layout.showMenu ? 'reverse' : ''
		},
		mainMenuItems () {
			return this.menuItems.filter(i => i.mainMenu !== false)
		},
		notTabMenuItems () {
			return this.menuItems.filter(i => i.tab === false && i.mainMenu === false)
		}
	}
}
</script>

<style lang="scss" scoped>
	.menuOverlay {
		background-color:$blue;
		width:80dvw;
		height:100%;
		top: 0;
		right: 0;
		bottom: 0;
		left:20%;
		position:fixed; 
		z-index:4;
		overflow-x: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;
		transition: all 0.5s ease;

		p {
			margin-bottom: 0;
			cursor: pointer;
		}
	}

	/* .menuOverlay::-webkit-scrollbar {
		display: none;
	} */

.backgroundOverlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background-color: $gray;
  opacity: 0.5;
	width: 100dvw;
}

.btn-close{
    position: fixed;
    background: $blue;
    color: $white;
    border: transparent;
    opacity: 1;
		border-radius: 50%;
		width: 50px;
		height: 50px;
		z-index: 3;
		@include tablets {
			top: 3dvh;
			left: 17.5dvw;
		}

		@include mobile {
			transform: translate(-22px, 11px);
		}
}

.overlayItems{
	margin: 3% 10% 10%;
}

p {
	color: $white;
	&.menuItem {
		margin-top: 0;
		margin-bottom: 0;
		display: inline-block;
	}
}

hr {
	&:not(.divider){
		@include media(tablets, mobile) {
			margin: .65rem 0;
		}
	}
}

.divider {
  background-color: $white;
  height: 2px;
	width: 100%;
	margin: 2rem 0;

	@include media(tablets, mobile) {
		margin: 1.25rem 0;
	}
}

.btn-change-user {
	margin-left: 2.5rem;
	color: $white;
	opacity: .5;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PrivateLayoutMobileSubmenu.vue